



































import {Component, Mixins} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {AppConfig} from '@/config/app.config'
import * as Helper from '@/helpers'
import FilterToggle from '@/components/FilterToggle.vue'
import AuditByDeliveryResponse from '@/model/response/AuditByDeliveryResponse'
import AuditByDeliveryCsvResponse from '@/model/response/AuditByDeliveryCsvResponse'
import FilterAuditByDelivery from '@/components/filters/FilterAuditByDelivery.vue'
import AuditByDeliveryRequest from '@/model/request/AuditByDeliveryRequest'
import moment from 'moment'

const metaInfo = () => ({
  title: $.t('view.reports.auditByDelivery.title'),
})

@Component({
  metaInfo,
  components: {FilterAuditByDelivery, FilterToggle},
})
export default class ReportsAuditByDeliveryView extends Mixins(MixinFilter) {
  filter = new AuditByDeliveryRequest()
  collection = new PageCollection(AuditByDeliveryResponse, this.filter, 10)

  AppConfig = AppConfig

  created() {
    this.filter.startDate = moment().format()
  }

  async downloadData(xlsx: boolean) {
    if (!xlsx) {
        const csv = new PageCollection(AuditByDeliveryCsvResponse, this.filter, null, null)

        const fetch = async () => await csv.search()
        await $.await.run(fetch, 'download')
        csv.downloadCsv($.t('view.reports.auditByDelivery.title'))
    } else {
        await $.await.run(() => Helper.downloadXlsx(
          $.t('view.reports.auditByDelivery.title'),
          new AuditByDeliveryCsvResponse().$endpoint,
          this.filter,
          AuditByDeliveryCsvResponse,
          'AuditByDeliveryCsvResponse',
          ), 'download')
    }
  }
}
